import styles from './OfferChoiceButtons.module.css';
import { useIntl } from 'react-intl';
import { OfferChoiceButton } from './OfferChoiceButton';
import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import orderBy from 'lodash/orderBy';
import interestOnlyMessages from '../interestOnly/InterestOnly.messages';
import durationChoiceMessages from './durationChoice.messages';

export const OfferChoiceButtons = ({
    updateSelectedOffer,
    formalOffers,
    drawdownAmount,
    hasInterestOnlyChoice
}: {
    updateSelectedOffer: (
        offer: NonNullable<GetFormalOffersResponse['data']>['formal_offers'][0]
    ) => void;
    formalOffers: NonNullable<GetFormalOffersResponse['data']>['formal_offers'];
    drawdownAmount: number;
    hasInterestOnlyChoice: boolean;
}) => {
    const intl = useIntl();

    const offers = orderBy(formalOffers, ['duration.amount'], 'asc');

    return (
        <>
            <p className="mt-2xl text-m font-bold">
                {hasInterestOnlyChoice
                    ? intl.formatMessage(
                          interestOnlyMessages.repaymentOptionHeading
                      )
                    : intl.formatMessage(
                          durationChoiceMessages.repaymentOptionHeading
                      )}
            </p>
            <div className={styles.radioButtonContainer}>
                {offers.map((offer) => (
                    <OfferChoiceButton
                        key={offer.offer_id}
                        offer={offer}
                        updateSelectedOffer={updateSelectedOffer}
                        drawdownAmount={drawdownAmount}
                    />
                ))}
            </div>
        </>
    );
};
